import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { useRef, useEffect } from 'react';
import axios from 'axios';
import { post } from '../../../../../../api';
import { trackException } from '../../../../../../helpers/errorTracker';

const LOCATIONS = { page: 1, perPage: 20 };

export const useLocationsFilter = ({ setFilters }) => {
  const cancelTokenSource = useRef(axios.CancelToken.source());

  useEffect(
    () => () => {
      cancelTokenSource.current.cancel();
    },
    [],
  );

  const formSchema = Yup.object().shape({
    locations: Yup.array().of(
      Yup.object().shape({
        label: Yup.string().required(),
        value: Yup.string().required(),
      }),
    ),
  });

  const onSearchChange = async (query) => {
    if (!query || !query.length) {
      return [];
    }

    try {
      const response = await post(
        `/locations/search/`,
        {
          q: {
            name: query,
            ...LOCATIONS,
          },
        },
        { cancelToken: cancelTokenSource.current.token },
      );

      return response.data.items.map(({ placeId, name }) => ({
        value: placeId,
        label: name,
      }));
    } catch (error) {
      if (!axios.isCancel(error)) {
        trackException(error);
      }
      return [];
    }
  };

  const onSubmit = ({ locations }) => {
    // Filter out remote from locations array (remote is handled separately)
    const filterLocations = (locations || []).filter((item) => item.value !== 'remote');

    // Build the locations base64 string
    let locationsParam = '';
    if (filterLocations.length) {
      locationsParam = btoa(JSON.stringify(filterLocations));
    }

    // Check if remote is in the locations array
    const hasRemote = (locations || []).some((item) => item.value === 'remote');
    const remoteValue = hasRemote ? 'remote' : '';

    setFilters({
      locations: filterLocations,
      locationsParam,
      remote: remoteValue,
    });
  };

  return {
    formSchema,
    onSearchChange,
    onSubmit,
  };
};

useLocationsFilter.propTypes = {
  setFilters: PropTypes.func.isRequired,
};
